import { DB_DATE_FORMAT } from 'core/constants';
import { formatDateForServer } from 'core/utils';

import { ITimeLog, IUpsertLogsFormData } from './types';

export const mapUpsertLogsForm = (jobId: number, data: IUpsertLogsFormData) => {
  return {
    bomLogs: data.timeLogs.map((timeLog: ITimeLog) => ({
      bomId: jobId,
      userId: data.user?.userId,
      bomTaskId: data.task?.id,
      activityDate:
        typeof timeLog.activityDate === 'string'
          ? timeLog.activityDate
          : formatDateForServer(timeLog.activityDate, DB_DATE_FORMAT),
      duration: timeLog.duration,
      note: data.note,
    })),
  };
};
